import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-20 sm:py-32 md:py-48 px-4 sm:px-6 flex flex-col items-center justify-center relative min-h-[60vh]" data-id="element-22">
      <div className="w-full max-w-4xl text-center relative z-10" data-id="element-23">
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-heading text-xl sm:text-2xl md:text-4xl text-brand-offWhite leading-relaxed font-light tracking-wide" data-id="element-24">
          We partner with ideas, operators, and projects positioned at the edge
          of culture and technology.
        </motion.p>
      </div>
    </section>;
}